import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'toLocalDate',
})
export class ToLocalDatePipe implements PipeTransform {
  transform(value: string) {
    if (value) {
      const date = new Date(value);
      const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
      return newDate.setHours(date.getHours() - date.getTimezoneOffset() / 60);
    }
  }
}
